
export default {
	guestList: state => state.guestList.map(id => state.guests[id]),
}